export default __webpack_public_path__ + "static/media/Instagram.abced1a1.png";